<template>
  <h1>Ajouter une évolution d'affaire et consulter mes brouillons</h1>

  <div class="affaires">
   

    <!-- 🟣 Liste des brouillons -->
    <ListeEvolAffaires @consulter-evolution="chargerEvolution" />

     <!-- 🟢 Bouton au-dessus -->
     <div class="actions-evol container" style="margin-bottom: 20px; text-align: right;">
      <button @click="demarrerNouvelleEvolution" class="btn">
        Démarrer une nouvelle évolution
      </button>
    </div>

    <!-- 🧩 Formulaire affiché uniquement quand demandé -->
    <div v-if="isFormVisible" style="margin-top: 30px;">
      <FormEvolAffaire ref="formEvol" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import FormEvolAffaire from '@/components/FormEvolAffaire.vue'
import ListeEvolAffaires from '@/components/ListeEvolAffaires.vue'

export default {
  components: { FormEvolAffaire, ListeEvolAffaires },
  data() {
    return {
      isLoading: false,
      isFormVisible: false // 👈 ajouté ici
    }
  },
  methods: {
    // 🟢 Ouvre le formulaire vide
    demarrerNouvelleEvolution() {
      this.isFormVisible = true
      this.$nextTick(() => {
        this.$refs.formEvol.demarrerNouvelleEvolution()
      })
    },

    // 🟣 Charge un brouillon et affiche le formulaire
    async chargerEvolution(id) {
      this.isLoading = true
      try {
        const response = await axios.post(
          'https://www.simef.fr/espace-client/api/getEvolAffaireById.php',
          { id }
        )

        const data = response.data
        if (data.evolution) {
          this.isFormVisible = true // 👈 on affiche le formulaire
          this.$nextTick(() => {
            this.$refs.formEvol.remplirDepuisBrouillon(data)
          })
        } else {
          console.warn('Aucune évolution trouvée.')
        }
      } catch (error) {
        console.error('Erreur lors du chargement de l’évolution :', error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.actions-evol .btn {
  background-color: #2b358d;
  color: #fff;
  border: none;
  padding: 10px 20px!important;
  border-radius: 0;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.actions-evol .btn:hover {
  background-color: #232c75;
}
</style>
